import React from 'react';
import { Table } from 'AWS-UI-Components-React';
import { ViewResultsForFeature } from './view_for_feature';
import { itemFailed, aggregateByFeatureName } from './utils';
import { TEST_RESULT } from './constants';

export class ViewByFeature extends React.Component {
  columnDefinitions = () => {
    return [
      {
        id: 'name',
        cell: (item) => (
          <ViewResultsForFeature
            testResultForFeature={item}
            loadValidationTestResults={this.props.loadValidationTestResults}
          />
        ),
      },
    ];
  };

  render() {
    const { validationTestResultItems } = this.props;

    const sortedByFailing = validationTestResultItems
      .map((item) => {
        return { ...item, itemFailed: itemFailed(item) };
      })
      .sort((a, b) => {
        return b.itemFailed - a.itemFailed;
      });

    const byFeature = aggregateByFeatureName(sortedByFailing);

    const testResultFeatures = Object.keys(byFeature).map((featureName) => {
      const scenarios = byFeature[featureName];
      const result = scenarios.every(s => !s.itemFailed) ? TEST_RESULT.PASS : TEST_RESULT.FAIL;
      return { feature: { name: featureName }, result, scenarios };
    });

    return (
      <Table
        loadingText="Loading test results..."
        columnDefinitions={this.columnDefinitions()}
        items={testResultFeatures}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/simulator/validation_test_results/view_by_feature.jsx